import React, { useState, useContext } from "react";
import blogFetch from "../axios/config";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Context from "../context/Context";
import language from '../nls/language.json';

function ScannerQR(props) {
  const [order, setOrder] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    selectedCountry
  } = useContext(Context);

  const getHeader = async (value) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    try {
      setError("");
      setLoading(true);
      const response = await blogFetch.get(`/SAGAViewFichaCabecalho/${trimmed}`);
      const header = response.data[0];
      if (header) {
        props.setCode(header);
      } else {
        setError("Erro: código não encontrado.");
      }
    } catch (error) {
      console.error(error);
      setError("Erro ao buscar dados no servidor.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    getHeader(order);
  };

  const handleAlertClose = () => {
    setError("");
    setOrder("");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 20px",
      }}
    >
      <p
        style={{
          fontSize: 16,
          fontWeight: 600,
          color: "#444",
          marginBottom: 20,
        }}
      >
        {language[selectedCountry.name].Dashboard.pesquisar.titulo}
      </p>
      <div
        style={{
          display: "flex",
          gap: 10,
          width: "100%",
          maxWidth: 480,
          alignItems: "center",
        }}
      >
        <TextField
          label="Ordem"
          variant="outlined"
          size="small"
          fullWidth
          value={order}
          onChange={(e) => setOrder(e.target.value)}
          disabled={loading}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#9e9e9e", fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#f8f9fa",
              fontSize: 14,
              "&:hover fieldset": { borderColor: "#9ed6de" },
              "&.Mui-focused fieldset": { borderColor: "#9ed6de" },
            },
          }}
        />
        <Button
          variant="contained"
          onClick={handleSearch}
          disabled={loading || !order.trim()}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            fontSize: 13,
            boxShadow: "none",
            minWidth: 100,
            height: 40,
            "&:hover": { boxShadow: "none" },
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            "Pesquisar"
          )}
        </Button>
      </div>
      {error && (
        <div style={{ marginTop: 16, width: "100%", maxWidth: 480 }}>
          <Alert
            severity="error"
            onClose={handleAlertClose}
            sx={{ borderRadius: "8px", fontSize: 13 }}
          >
            {error}
          </Alert>
        </div>
      )}
    </div>
  );
}

export default ScannerQR;
